// Data for sponsorer og støtter hos Tak For Din Indsats (TFDI)
// Nemt at redigere og tilføje nye sponsorer fortløbende.

export const SPONSORS_DATA = [
  // 2025-2026 (Nyeste sponsorer fra Sponsor.docx)
  {
    id: "mydefence",
    name: "MyDefence",
    subtitle: "Counter UAS Technology",
    category: "Forsvar & Teknologi",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image1.emf",
    type: "company"
  },
  {
    id: "utzon-center",
    name: "Utzon Center",
    subtitle: "Kultur & Arkitektur",
    category: "Kultur",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image2.emf",
    type: "company"
  },
  {
    id: "thomas-rathsack",
    name: "Thomas Rathsack",
    subtitle: "Veteran, forfatter & foredragsholder (#LFH)",
    category: "Personlig støtte",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image3.emf",
    type: "person"
  },
  {
    id: "rebild-boxen",
    name: "Rebild BOXEN",
    subtitle: "Opbevaring & Erhverv",
    category: "Erhverv",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image4.emf",
    type: "company"
  },
  {
    id: "tommy-rasmussen",
    name: "Tommy Rasmussen",
    subtitle: "Privat støtte & erhverv",
    category: "Personlig støtte",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image5.emf",
    type: "person"
  },
  {
    id: "gedulgt",
    name: "Gedulgt",
    subtitle: "Cocktailbar & Gastronomi",
    category: "Gastronomi",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image6.emf",
    type: "company"
  },
  {
    id: "nordens-florist",
    name: "Nordens Florist",
    subtitle: "Blomster & Bæredygtighed",
    category: "Detail",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image7.emf",
    type: "company"
  },
  {
    id: "mads-blom",
    name: "Mads Blom",
    subtitle: "Personlig støtte",
    category: "Personlig støtte",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image8.emf",
    type: "person"
  },
  {
    id: "rarewine-invest",
    name: "RareWine Invest",
    subtitle: "Vininvestering & Kapitalforvaltning",
    category: "Finans",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image9.emf",
    type: "company"
  },
  {
    id: "foa",
    name: "FOA",
    subtitle: "Fagforbund for offentligt ansatte",
    category: "Organisation",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image10.emf",
    type: "company"
  },
  {
    id: "galleri-stubberup",
    name: "Galleri Stubberup",
    subtitle: "Kunst & Galleri",
    category: "Kultur",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image11.png",
    type: "company"
  },
  {
    id: "skuas-foodstudio",
    name: "Skuas Foodstudio",
    subtitle: "Catering & Gastronomi",
    category: "Gastronomi",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image12.emf",
    type: "company"
  },
  {
    id: "hoerkram",
    name: "Hørkram Foodservice",
    subtitle: "Fødevaregrossist",
    category: "Fødevarer",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image13.emf",
    type: "company"
  },
  {
    id: "lars-pank",
    name: "Lars Pank",
    subtitle: "Personlig støtte & Erhverv",
    category: "Personlig støtte",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image14.emf",
    type: "person"
  },
  {
    id: "stark",
    name: "STARK",
    subtitle: "Det professionelle byggemarked",
    category: "Byggeri & Erhverv",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image15.emf",
    type: "company"
  },
  {
    id: "bankbox-aabybro",
    name: "Bankbox Aabybro",
    subtitle: "Sikkerhed & Opbevaring",
    category: "Finans & Sikkerhed",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image16.emf",
    type: "company"
  },
  {
    id: "sound-and-light",
    name: "Sound & Light",
    subtitle: "Lyd, Lys & Eventproduktion",
    category: "Event & Teknik",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image17.png",
    type: "company"
  },
  {
    id: "tyr-tactical",
    name: "TYR Tactical",
    subtitle: "Taktisk udrustning & beskyttelse",
    category: "Forsvar & Udstyr",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image18.png",
    type: "company"
  },
  {
    id: "sparekassen-danmark",
    name: "Sparekassen Danmark",
    subtitle: "Garantsparekasse & Samfundsstøtte",
    category: "Finans",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image19.emf",
    type: "company"
  },
  {
    id: "jydsk-emblem-fabrik",
    name: "Jydsk Emblem Fabrik (JEF.dk)",
    subtitle: "Emblemer, medaljer & merchandise",
    category: "Produktion & Handel",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image20.png",
    type: "company"
  },
  {
    id: "henrik-busk-andersen",
    name: "Henrik Busk Andersen",
    subtitle: "Billedkunstner & forfatter",
    category: "Kunst & Kultur",
    year: "2025–2026",
    isLatest: true,
    fileKey: "media/image21.png",
    type: "person"
  },

  // 2024 (Tidligere / stiftende sponsorer)
  {
    id: "engage-festival",
    name: "Engage Festival",
    subtitle: "Musikfestival af og for veteraner",
    category: "Event & Kultur",
    year: "2024",
    isLatest: false,
    logo: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 240 160'><rect width='240' height='160' fill='%23fcd34d' rx='10'/><path d='M24 45L216 28L210 118L140 123L126 142L120 125L24 130Z' fill='%23e11d48'/><text x='120' y='96' fill='%23ffffff' font-family='system-ui,sans-serif' font-weight='900' font-size='34' letter-spacing='1' text-anchor='middle' transform='rotate(-4 120 90)'>ENGAGE</text></svg>",
    type: "company"
  },
  {
    id: "sebc-holding",
    name: "SEBC Holding",
    subtitle: "Investering & Erhvervsudvikling",
    category: "Finans & Investering",
    year: "2024",
    isLatest: false,
    logo: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 260 140'><rect width='260' height='140' fill='%23000000' rx='8'/><text x='130' y='64' fill='%23ffffff' font-family='Times New Roman,serif' font-weight='bold' font-size='36' letter-spacing='3' text-anchor='middle'>SEBC</text><line x1='35' y1='80' x2='225' y2='80' stroke='%23ffffff' stroke-width='1.5'/><text x='130' y='108' fill='%23ffffff' font-family='Times New Roman,serif' font-weight='600' font-size='20' letter-spacing='5' text-anchor='middle'>HOLDING</text></svg>",
    type: "company"
  },
  {
    id: "vestevent",
    name: "Vestevent",
    subtitle: "Friluftsoplevelser & events",
    category: "Events & Oplevelser",
    year: "2024",
    isLatest: false,
    logo: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 280 110'><polygon points='20,10 275,0 260,100 5,110' fill='%2300d589'/><text x='140' y='72' fill='%23ffffff' font-family='system-ui,sans-serif' font-weight='900' font-style='italic' font-size='34' letter-spacing='1' text-anchor='middle'>VESTEVENT</text></svg>",
    type: "company"
  },
  {
    id: "eventech",
    name: "Eventech",
    subtitle: "Event-teknologi & Løsninger",
    category: "Teknik & Events",
    year: "2024",
    isLatest: false,
    logo: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 280 100'><g transform='translate(15,12)'><path d='M40 10 C20 10 5 30 5 45 C5 65 25 75 45 68 C30 65 20 52 25 40 C30 25 55 25 60 12 Z' fill='%230284c7'/><path d='M25 40 C35 15 60 20 65 35 C70 50 50 68 30 72 C50 72 65 58 62 42 Z' fill='%2338bdf8'/></g><text x='95' y='58' fill='%230284c7' font-family='system-ui,sans-serif' font-weight='900' font-size='30' letter-spacing='1.5'>EVENTECH</text></svg>",
    type: "company"
  },
  {
    id: "rally-point-tactical",
    name: "Rally Point Tactical",
    subtitle: "Taktisk beklædning & grej",
    category: "Forsvar & Udstyr",
    year: "2024",
    isLatest: false,
    logo: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 300 120'><rect width='300' height='120' fill='%23111827' rx='8'/><g transform='translate(25,18)'><polygon points='30,5 55,75 30,60 5,75' fill='%23dc2626'/><polygon points='30,5 30,85 18,90 22,65' fill='%23ffffff'/></g><text x='92' y='52' fill='%23ffffff' font-family='system-ui,sans-serif' font-weight='800' font-size='22' letter-spacing='0.5'>Rally Point</text><text x='92' y='80' fill='%23e2e8f0' font-family='system-ui,sans-serif' font-weight='500' font-size='18' letter-spacing='1'>Tactical</text></svg>",
    type: "company"
  },
  {
    id: "mai-event",
    name: "MAI-Event",
    subtitle: "Eventplanlægning & afvikling",
    category: "Events",
    year: "2024",
    isLatest: false,
    logo: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 280 110'><rect width='280' height='110' fill='%23000000' rx='8'/><text x='140' y='60' fill='%23ffffff' font-family='system-ui,sans-serif' font-weight='800' font-size='28' letter-spacing='3' text-anchor='middle'>MAI-EVENT</text><path d='M30 85 Q140 60 250 85' stroke='%23ffffff' stroke-width='2.5' fill='none'/></svg>",
    type: "company"
  },
  {
    id: "thomas-rode",
    name: "Thomas Rode",
    subtitle: "Kok, forfatter & sundhedsrådgiver",
    category: "Personlig støtte",
    year: "2024",
    isLatest: false,
    type: "person"
  },
  {
    id: "mikael-kopp",
    name: "Mikael Kopp",
    subtitle: "Personlig støtte",
    category: "Personlig støtte",
    year: "2024",
    isLatest: false,
    type: "person"
  },
  {
    id: "jessie-ka",
    name: "Jessie Ka",
    subtitle: "Personlig støtte",
    category: "Personlig støtte",
    year: "2024",
    isLatest: false,
    type: "person"
  },
  {
    id: "mads-kjaer-krabat",
    name: "Mads Kjær Krabat",
    subtitle: "Personlig støtte",
    category: "Personlig støtte",
    year: "2024",
    isLatest: false,
    type: "person"
  },
  {
    id: "m-and-m",
    name: "M&M",
    subtitle: "Erhverv & støtte",
    category: "Erhverv",
    year: "2024",
    isLatest: false,
    logo: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 90'><text x='100' y='58' fill='%231e293b' font-family='Times New Roman,serif' font-weight='bold' font-size='38' letter-spacing='2' text-anchor='middle'>M%26M</text></svg>",
    type: "company"
  }
];
